
export class DeliverableListingDto {
    Id: number;
    SiteNumber: number;
    SiteName: string;
    DeliverableName: string;
    DeliverableId: number;
    ExpectedDueDate: string;
    StatusName: string;
    StatusId: number;
    StudyName: string;
    CompletionDate: string;
    ExpirationDate: string;
    ModificationNumber: string;
    Comment: string;

    constructor() { }

    matchesFilter(site: any, status: any, expectedDueDate: string, completionDate: string): boolean {
        // Site filter
        if (site && site.length > 0 && !site.includes(this.SiteName)) return false;
        // Status filter
        if (status && status.length > 0 && !status.includes(this.StatusName)) return false;
        // Expected Due Date filter
        if (expectedDueDate && expectedDueDate !== "" && this.ExpectedDueDate !== expectedDueDate) return false;
        // Completion Date filter
        if (completionDate && completionDate !== "" && this.CompletionDate !== completionDate) return false;

        return true;
    }
}